module.exports = __webpack_public_path__ + "img/build-waterproofing-1.a068043d.jpg";